// extracted by mini-css-extract-plugin
module.exports = {"field":"Forms_field__1xzKi","form":"Forms_form__1jtUq","controlWrapper":"Forms_controlWrapper__2kzB4","control":"Forms_control__2rJxU","label":"Forms_label__2EOsX"};